import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewersService } from '../../../../services/viewers.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-close-fullscreen-button',
  imports: [],
  templateUrl: './close-fullscreen-button.component.html',
  styleUrl: './close-fullscreen-button.component.css'
})
export class CloseFullscreenButtonComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  public isFullscreen: boolean = false;

  constructor(
    private readonly viewersService: ViewersService
  ) { }

  ngOnInit(): void {
    // Get fullscreen status
    this.checkFullscreen();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
  
  private checkFullscreen() {
    const fullscreen3dEnabled = this.viewersService.viewer3d
      .getObservable('fullscreen_enabled')
      .subscribe((err) => {
        // console.log('3D Viewer Fullscreen Enabled', err);
        this.isFullscreen = true;
      });

    const fullscreen3dDisabled = this.viewersService.viewer3d
      .getObservable('fullscreen_disabled')
      .subscribe((err) => {
        // console.log('3D Viewer Fullscreen Disabled', err);
        this.isFullscreen = false;
      });

    // Subscriptions
    this.subscriptions.push(fullscreen3dEnabled, fullscreen3dDisabled);
  }
  
  public onFullscreen() {
    this.viewersService.viewer3d.toggleFullscreen();
    if(this.viewersService.viewer3d.vr.flags.vr_enabled){
      this.viewersService.viewer3d.vr.toggleVR();
    }
    
  }

}
